var _excluded = ["rounded", "size"],
  _excluded2 = ["outlined"];
var _templateObject, _templateObject2, _templateObject3;
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Loader as KendoLoader } from '@progress/kendo-react-indicators';
import { borderRadius } from '../../common';
var StyledOutline = styled(_ref => {
  var {
      rounded,
      size
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", rest);
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", "\n"])), props => css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        background: ", ";\n        border-color: ", ";\n        border-radius: ", ";\n        border-style: solid;\n        border-width: 1px;\n        padding: 0.5rem;\n        z-index: 1;\n    "])), props.theme.component.baseBg, props.theme.component.baseBorder, borderRadius(props)));
var StyledLoader = styled(_ref2 => {
  var {
      outlined
    } = _ref2,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(KendoLoader, rest);
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    display: flex;\n"])));

/**
 * The Loader component is a visual indicator that expresses an indeterminate wait time.
 * It informs users about the status of ongoing processes, such as loading an app,
 * submitting a form, saving updates or fetching data.
 */
var Loader = props => {
  var {
    outlined,
    size
  } = props;
  if (outlined) {
    return /*#__PURE__*/React.createElement(StyledOutline, {
      size: size
    }, /*#__PURE__*/React.createElement(StyledLoader, props));
  }
  return /*#__PURE__*/React.createElement(StyledLoader, props);
};
Loader.defaultProps = {
  className: undefined,
  outlined: false,
  rounded: 'medium',
  size: 'medium',
  style: undefined,
  themeColor: 'primary',
  type: 'pulsing'
};
Loader.propTypes = {
  /**
   * Specifies a list of CSS classes that will be added to the Loader.
   */
  className: PropTypes.string,
  /**
   * Determines if the Loader should have an outline with a white background.
   */
  outlined: PropTypes.bool,
  /**
   * Configures the roundness of the Loader outline.
   * The available options are: 'small' | 'medium' | 'large' | 'full'
   */
  rounded: PropTypes.oneOf(['small', 'medium', 'large', 'full']),
  /**
   * Specifies the size of the Loader.
   * The possible values are: 'small' | 'medium' | 'large'
   */
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  /**
   * Sets additional CSS styles to the Loader.
   */
  style: PropTypes.shape({}),
  /**
   * Specifies the theme color of the Loader.
   * The possible values are: 'primary' | 'secondary' | 'tertiary' | 'info' |
   * 'success' | 'warning' | 'error' | 'dark' | 'light' | 'inverse'
   */
  themeColor: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'info', 'success', 'warning', 'error', 'dark', 'light', 'inverse']),
  /**
   * Specifies the Loader animation type.
   * The possible values are: 'pulsing' | 'infinite-spinner' | 'converging-spinner'
   */
  type: PropTypes.oneOf(['pulsing', 'infinite-spinner', 'converging-spinner'])
};
export default Loader;